import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Clock } from 'lucide-react';

interface LanguageSelectProps {
  value: string;
  onChange: (value: string) => void;
}

const languages = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish (Coming Soon)', disabled: true },
  { value: 'fr', label: 'French (Coming Soon)', disabled: true },
  { value: 'de', label: 'German (Coming Soon)', disabled: true },
];

export function LanguageSelect({ value, onChange }: LanguageSelectProps) {
  return (
    <div className="mb-6">
      <label className="text-sm font-medium mb-2 block">Language</label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select language" />
        </SelectTrigger>
        <SelectContent>
          {languages.map((language) => (
            <SelectItem 
              key={language.value} 
              value={language.value}
              disabled={language.disabled}
            >
              {language.label}
              {language.disabled && (
                <Clock className="inline-block ml-2 h-4 w-4 text-muted-foreground" />
              )}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}